module.exports = __webpack_public_path__ + "img/9788995529744.0414428e.jpg";